import "./PoliQueue.scss";
import 'moment/locale/id';

import { isStr, parseNumberToPath, parseQueue, playSoundByPath } from "common/utils";
import FullScreenPage from "components/fullscreen"
import { useEffect } from "react";
import Moment from "react-moment"

import { backgroundPoli, kfIconGroup } from "../assets/images"

const mappingSoundPoli: Record<string, string> = {
    "akupuntur": "poliAkupuntur",
    "anak": "poliAnak",
    "gigi": "poliGigiDanMulut",
    "kandungan": "poliKandungan",
    "kulit": "poliKulitDanKelamin",
    "mata": "poliMata",
    "penyakit dalam": "poliPenyakitDalam",
    "umum": "poliUmum"
}


async function playSoundPoli(queue = '', poliName = '') {
    if (!mappingSoundPoli[poliName]) {
        return;
    }

    const audioPath: any[] = [];
    audioPath.push('intro', 'patientWithNumber');

    const queueArr = parseQueue(queue);
    queueArr.forEach(q => {
        if (isStr(q)) {
            [...q].forEach((key: string) => {
                audioPath.push(`alphabet${key.toUpperCase()}`);
            })
        } else {
            parseNumberToPath(Number(q), audioPath);
        }
    })

    const sound: Record<string, any> =  await import("../assets/sounds/index");
    const soundPoli: Record<string, any> =  await import("../assets/sound-poli/index");

    if (sound && soundPoli) {
        let paths = audioPath.map(e => sound[e]);

        paths.push(soundPoli[mappingSoundPoli[poliName]])
        paths = paths.filter( e => e !== undefined);
        playSoundByPath(paths.reverse(), paths.length);
    }
}
export const PoliQueue = () => {
    useEffect(() => {
        (window as any).playSound = playSoundPoli;
    }, []);
    return (
        <div id="poli-queue" className="flex flex-col justify-center w-screen h-screen"
            style={{backgroundImage: `url(${backgroundPoli})`}}>
            <FullScreenPage pageId="poli-queue" />
            <div className='w-full flex justify-center items-center z-10'>
                <div className="w-max flex flex-col gap-6">
                    <div className=" bg-[#E4E6F8] rounded-lg flex justify-between">
                        <div className='bg-white rounded-2xl pl-[2rem] w-full'>
                           <img src={kfIconGroup}  alt="" className='h-[6rem]'/>
                        </div>
                        <div className='flex gap-4 items-center p-4 w-full justify-end'>
                            <div className='flex flex-col items-end  text-2xl'>
                                <Moment locale="id" interval={30_000} format="dddd"></Moment>
                                <Moment locale="id" interval={30_000} format="DD MMM YYYY"></Moment>
                            </div>
                            <div className='bg-[#B8B9C6] w-[1px] my-1 h-full' />
                            <div className='text-[#4A57CD] text-5xl '>
                                <Moment interval={1000} format="HH:mm"></Moment>
                            </div>
                        </div>
                    </div>
                    <div className='bg-white flex flex-col p-10 rounded-3xl'>
                        <div className='text-center text-7xl font-bold text-[#4A57CD] p-[3rem]'>
                            Loket 2
                        </div>
                        <div className='current-queue-number'>
                            M37
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}